<template>
    <v-card tile flat>
        <v-app-bar color="white" flat fixed class="divider-app-bar">
            <v-row align="center" no-gutters>
                <v-col cols="2">
                    <v-btn icon @click="hide" color="#333333">
                        <v-icon>$close</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="8" class="app-title">
                    {{ $t('common.filter') }}
                </v-col>
                <v-col cols="2" align="right">
                    <v-btn @click="reset" icon>
                        <v-icon>mdi-filter-remove-outline</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-app-bar>

        <v-sheet height="72" color="transparent"/>

        <v-card-text>

            <v-row>
                <!-- SPORTS -->
                <v-col cols="12" md="6">
                    <div class="subtitle">
                        {{ $t('common.filter_sport') }}
                    </div>
                    <v-divider/>
                    <kimsa-combobox
                        color="secondary"
                        :items="sports"
                        :placeholder="$t('common.filter_sport_placeholder')"
                        @change="sportSelected = $event"
                        withInfo
                        multiple
                        ref="sports"
                    />
                </v-col>

                <!-- OBJECTIVES -->
                <v-col cols="12" md="6">
                    <div class="subtitle">
                        {{ $t('common.filter_objectives') }}
                    </div>
                    <v-divider/>
                    <kimsa-select
                        :items="objectives"
                        @change="objectivesArray = $event"
                        multiple chip bordered
                        ref="objectives"
                    />
                </v-col>

                <!-- COUNTRY -->
                <v-col cols="12" md="6">
                    <div class="subtitle">
                        {{ $t('common.filter_country') }}
                    </div>
                    <v-divider/>
                    <kimsa-combobox
                        color="secondary"
                        :items="countries"
                        :placeholder="$t('common.search_place')"
                        @change="countrySelected = $event"
                        ref="places"
                    />
                </v-col>

                <!-- RATING -->
                <v-col cols="12" md="6">
                    <div class="subtitle">
                        {{ $t('common.filter_rating') }}
                    </div>
                    <v-divider/>
                    <v-range-slider
                        track-color="secondary"
                        color="accent"
                        v-model="ratingRange"
                        min="0"
                        max="5"
                        ticks="always"
                        tick-size="0"
                        :tick-labels="['0',1,2,3,4,5]"
                    />
                </v-col>
            </v-row>

            <div class="container-bottom-button">
                <div class="bottom-button">
                    <v-btn @click="filter" color="primary" class="normal-btn black--text" block depressed large>
                        {{ $t('common.filter') }}
                    </v-btn>
                </div>
            </div>

        </v-card-text>

    </v-card>
</template>

<script>

import KimsaCombobox from '@/components/common/inputs/KimsaCombobox'
import KimsaSelect from '@/components/common/inputs/KimsaSelect'

import {mapState, mapMutations, mapActions} from 'vuex'

export default {
    components: {
        KimsaCombobox,
        KimsaSelect,
    },
    data() {
        return {
            sportSelected: [],
            objectivesArray: [],
            countrySelected: '',
            ratingRange: [0, 5],
        }
    },
    computed: {
        ...mapState(['config', 'countries']),
        objectives(vm = this) {
            if (!vm.config) return []
            return vm.config.objectives.map(objective => ({name: objective, value: objective}))
        },
        sports(vm = this) {
            if (!vm.config) return []
            return vm.config.sports.map(sport => ({name: sport, value: sport}))
        },
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        if (vm.countries.length === 0) await vm.bindCountries()
    },
    methods: {
        ...mapMutations(['setFilterCoach']),
        ...mapActions(['bindConfig', 'bindCountries']),
        hide() {
            const vm = this
            vm.$emit('hide')
        },
        reset() {
            const vm = this
            vm.$refs.sports.array = []
            vm.$refs.objectives.array = []
            vm.$refs.places.model = ''
            vm.ratingRange = [0, 5]
        },
        filter() {
            const vm = this

            let sports = vm.sportSelected.map(s => s.value)
            let objectives = vm.objectivesArray
            let country = vm.countrySelected
            let ratingRange = vm.ratingRange

            let filter = '(accountType:coach AND readyToTrain=1) ' // COACH
            if (sports.length > 0) filter += `AND (sport_areas:'${sports.join("' OR sport_areas:'")}') ` // SPORTS
            if (objectives.length > 0) filter += `AND (objectives:'${objectives.join("' OR objectives:'")}') ` // OBJECTIVES
            if (country !== null && country !== '' && country !== undefined) filter += `AND (country.name:'${country.name}') ` // COUNTRY
            filter += `AND ((rating.stars:${ratingRange[0]} TO ${ratingRange[1]})) ` // RATING

            vm.setFilterCoach(filter)
            vm.$emit('hide')
        }
    },
}

</script>

<style scoped>

.app-title {
    color: #333333;
    font-size: 17px;
    text-align: center;
}

.divider-app-bar {
    border-bottom: 2px solid var(--v-accent-base) !important;
}

.v-divider {
    height: 2px;
    max-height: 10px;
    background-color: var(--v-primary-base);
    margin-top: 4px;
    margin-bottom: 4px;
}

.subtitle {
    font-size: 17px;
    font-weight: bold;
    color: var(--v-accent-base);
}

.bottom-button {
    display: flex;
    position: fixed;
    bottom: 0%;
    left: 0%;
    width: 100%;
    padding: 10px;
    background-color: white;
    z-index: 6;
}

.container-bottom-button {
    margin-top: 50px;
}

::v-deep .v-slider__tick {
    color: var(--v-secondary-base);
}

</style>